var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { AddOperation, DeltaUpdateOperation, SchemaObject, SignalOperation, UpdateOperation } from '@augloop/types-core';
import { Log, LogCategory, Operation as LogOperation } from '@augloop/logging';
var supportedOperationSet = new Set([
    AddOperation.getTypeName(),
    UpdateOperation.getTypeName(),
    SignalOperation.getTypeName(),
    DeltaUpdateOperation.getTypeName()
]);
var ContextIdManager = /** @class */ (function () {
    function ContextIdManager(runtimeKind, workflowGraph) {
        this.workflowGraph = workflowGraph;
        this.contextIdTracker = new ContextIdTracker(runtimeKind);
    }
    ContextIdManager.prototype.applyContextIdOnOperations = function (ops) {
        var e_1, _a, e_2, _b;
        try {
            for (var ops_1 = __values(ops), ops_1_1 = ops_1.next(); !ops_1_1.done; ops_1_1 = ops_1.next()) {
                var op = ops_1_1.value;
                var opType = SchemaObject.getTypeNameFor(op);
                if (!this.isSupportedOperation(opType)) {
                    continue;
                }
                try {
                    for (var _c = (e_2 = void 0, __values(op.items)), _d = _c.next(); !_d.done; _d = _c.next()) {
                        var item = _d.value;
                        if (!item.contextId) {
                            item.contextId = this.contextIdTracker.addRoot();
                            continue;
                        }
                        if (item.source && this.workflowGraph.getWorkflow(item.source, false /** external */)) {
                            item.contextId = this.contextIdTracker.addChild(item.contextId);
                            continue;
                        }
                        this.tryLogMessage(new LogOperation({ operationName: 'ApplyContextIdOnOperations', success: true }).start(), 'Item with a contextId but without a workflow source atribute');
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (ops_1_1 && !ops_1_1.done && (_a = ops_1.return)) _a.call(ops_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    ContextIdManager.prototype.isSupportedOperation = function (operationType) {
        return supportedOperationSet.has(operationType);
    };
    ContextIdManager.prototype.tryLogMessage = function (logOp, message, success) {
        if (success === void 0) { success = true; }
        if (logOp) {
            logOp.success = success;
            logOp.resultDescription = message;
            Log.verbose(0x1f6e1759 /* tag_5173z */, LogCategory.CoreDefault, logOp.stop());
        }
    };
    return ContextIdManager;
}());
export { ContextIdManager };
var ContextIdTracker = /** @class */ (function () {
    function ContextIdTracker(runtimeKind) {
        this.rootCount = 0;
        this.children = new Map();
        this.runtimeKind = runtimeKind;
    }
    ContextIdTracker.prototype.addRoot = function () {
        this.rootCount++;
        var nodeKey = this.buildNodeKey(this.rootCount);
        this.increaseChildCount(nodeKey);
        return nodeKey;
    };
    ContextIdTracker.prototype.addChild = function (parentKey) {
        if (!this.children.has(parentKey)) {
            this.increaseChildCount(parentKey);
        }
        var parentChildrenCount = this.children.get(parentKey);
        var key = parentKey + '.' + this.buildNodeKey(parentChildrenCount + 1);
        this.increaseChildCount(parentKey);
        this.increaseChildCount(key);
        return key;
    };
    ContextIdTracker.prototype.increaseChildCount = function (key) {
        try {
            this.children.set(key, this.children.has(key) ? this.children.get(key) + 1 : 0);
        }
        catch (error) {
            // TODO 6138147: Clear entries on ContextIdTracker map
            var logOp = new LogOperation({ operationName: 'ContextIdTracker', resultDescription: "key: ".concat(key, ", rootCount: ").concat(this.rootCount, ", children map size: ").concat(this.children.size, ". Error: ").concat(error), success: true }).start();
            Log.error(0x1f407861 /* tag_5qh77 */, LogCategory.CoreDefault, logOp.stop());
        }
    };
    ContextIdTracker.prototype.buildNodeKey = function (count, id) {
        if (id === void 0) { id = this.runtimeKind; }
        return id + count.toString();
    };
    return ContextIdTracker;
}());
export { ContextIdTracker };
//# sourceMappingURL=context-id-manager.js.map